import styled from 'styled-components';

import Link from '~/src/common/components/Link/Link';
import { media } from '~/src/styles-constants';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 16px;
  line-height: 20px;

  ${media.M`
    gap: 24px;
  `}
`;

export const Details = styled(Link)`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  align-self: flex-end;
`;
